'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Faq = exports.FaqUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _multitrack = require('helpers/multitrack');

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaqUnwrapped = exports.FaqUnwrapped = function (_Component) {
  (0, _inherits3.default)(FaqUnwrapped, _Component);

  function FaqUnwrapped(props) {
    (0, _classCallCheck3.default)(this, FaqUnwrapped);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (FaqUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(FaqUnwrapped)).call(this, props));

    _this2.state = {};
    return _this2;
  }

  (0, _createClass3.default)(FaqUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      (0, _multitrack.ga)('FAQ Module', 'Viewed FAQ module', '', 0, { nonInteraction: true });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(index, question) {
      this.setState((0, _defineProperty3.default)({}, 'q' + index, !this.state['q' + index]));
      if (!this.state['q' + index]) {
        (0, _multitrack.ga)('FAQ Module', 'Expanded question', question, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var _props = this.props,
          title = _props.title,
          faq = _props.faq,
          backgroundColor = _props.backgroundColor;


      return _react2.default.createElement(
        'div',
        { className: 'bg--' + (backgroundColor || 'white') },
        _react2.default.createElement(
          'div',
          { className: 'pricing-faq' },
          _react2.default.createElement(
            'h2',
            { className: 'gamma' },
            title
          ),
          _react2.default.createElement(
            'ul',
            null,
            faq.map(function (q, i) {
              return _react2.default.createElement(
                'li',
                {
                  // eslint-disable-next-line react/no-array-index-key
                  key: i,
                  onClick: function onClick() {
                    return _this.handleClick(i, q.question);
                  }
                },
                _react2.default.createElement(
                  'h3',
                  null,
                  _react2.default.createElement(_reactInlinesvg2.default, {
                    className: (0, _classnames2.default)('pricing-faq__arrow', { selected: _this.state['q' + i] || false }),
                    uniquifyIDs: false,
                    src: require('../../../../../static/img/arrow.svg')
                  }),
                  q.question
                ),
                !!_this.state['q' + i] && _react2.default.createElement(
                  'p',
                  null,
                  q.answer
                )
              );
            })
          )
        )
      );
    }
  }]);
  return FaqUnwrapped;
}(_react.Component);

FaqUnwrapped.propTypes = {
  backgroundColor: _propTypes2.default.oneOf(['white', 'light']),
  faq: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    answer: _propTypes2.default.string,
    question: _propTypes2.default.string,
    type: _propTypes2.default.string
  })),
  title: _propTypes2.default.string
};

FaqUnwrapped.propMapper = function (state, moduleDef) {
  return {
    title: moduleDef.title,
    faq: moduleDef.questions
  };
};

var Faq = exports.Faq = (0, _TrackDwell2.default)(FaqUnwrapped);